export default "__VITE_ASSET__BC12MicN__"